var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_-",
    "data-name": "icona -",
    transform: "translate(-542 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_--2",
    "data-name": "icona -",
    transform: "translate(535.5 53.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_459",
    "data-name": "Tracciato 459",
    d: "M7.5,18h16",
    transform: "translate(0 -2.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1831",
    "data-name": "Rettangolo 1831",
    transform: "translate(543 61)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.7c83369c27ca1b77765acc11e0bdb830.svg";
export { ForwardRef as ReactComponent };